import { render } from "./Popular.vue?vue&type=template&id=533afc34&scoped=true"
import script from "./Popular.vue?vue&type=script&lang=js"
export * from "./Popular.vue?vue&type=script&lang=js"

import "./Popular.vue?vue&type=style&index=0&id=533afc34&scoped=true&lang=css"
import "./Popular.vue?vue&type=style&index=1&id=533afc34&scoped=true&lang=css"

import exportComponent from "F:\\App-themes\\clickon\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-533afc34"]])

export default __exports__